import { Badge } from "@shared-components/shadcn/badge";
import { cn } from "@shared-utils/ui";
import { CircleX } from "lucide-react";
import { type ReactNode } from "react";

interface DepartmentBadgeProps {
  onClick: () => void;
  children: string | ReactNode;
}

export const DepartmentBadge = (props: DepartmentBadgeProps) => {
  return (
    <Badge
      size={"lg"}
      variant={"default"}
      onClick={(e) => {
        if (props.onClick) {
          e.preventDefault();
          e.stopPropagation();
          props.onClick();
        }
      }}
      className={cn("facet-badge relative m-0.5 mt-1 p-2 whitespace-nowrap", {
        "cursor-pointer": Boolean(props.onClick),
      })}
    >
      {props.children}
      {Boolean(props.onClick) && <CircleX className="ml-1" size={14} />}
    </Badge>
  );
};
